<template>
    <layout-with-sidebar>
        <HeaderComponent/>
        <div class=" ed-bg text-color" style="min-height:100vh;overflow-x: scroll">
            <div class="container-fluid">

                <TableShort/>
            </div>
        </div>
    </layout-with-sidebar>
</template>

<script>
    import LayoutWithSidebar from '../../components/layouts/LayoutWithSidebar.vue'
    import HeaderComponent from '../../components/HeaderComponent.vue'
    import TableShort from '../../components/TableShort.vue'

    export default {
        name: 'SearchPromissoryNotes',
        components: {
            LayoutWithSidebar,
            HeaderComponent,
            TableShort
        },
        data: function () {
            return {
                amortizations: [],
            }
        },
        computed: {},
        methods: {}
    }

</script>


<style scoped>
    .bg-blue-ed {
        background-color: #222939 !important;
        color: white !important;
    }

    .heightPage {
        height: 100vh; /*Altezza importante = (Row Header Page + Row MainContent)*/
        background-color: red;
    }


    /*Set the row height to the viewport*/
    /*Altezza importante = (Row Header Page + Row MainContent)*/
    .row-height-scroll {
        height: 92.8vh;
    }

    /* .heightHeader{ height: 7vh; } */
    .heightContent {
        height: 93vh;
    }


    .bg-white-ed {
        background-color: white;
    }

    .bg-gry {
        background-color: #E3E3E3 !important
    }

    /*Set up the columns with a 100% height, body color and overflow scroll*/

    .scrollbox {
        /* background-color: red; */
        height: 89%;
        height: 98%; /* Altezza importante*/
        height: 89%;
        height: 99%;

        padding-bottom: 30px;
        overflow-y: scroll;
        min-width: 100%;
    }

    .right {
        background-color: blue;
        height: 100%;
        overflow-y: scroll;
    }

    .mid {
        background-color: green;
        height: 100%;
        overflow-y: scroll;
    }

    .ed-bg{
        background-color: #272F44;
        background-color: #222939;
        color: white;
    }
</style>
